import useRotas from "@/Composables/useRotas";

export default function useGerarImagem() {
    const route = useRotas();
    return (id) => {
        return route("midia.arquivo", {
            idArquivo: id,
        });
    };
}
